import React, { Fragment } from 'react';
import { bool, number, oneOf } from 'prop-types';
import { usePaginationOffset, useFeatureFlags } from 'hooks';
import {
    PositionedCard,
    TipsheetCard,
    QuickFiltersWrapper,
} from './components';
import {
    getTargetPosition,
    getGap,
    getElementIndex,
} from './InGridElementsWrapper.utils';
import useInGridElements from './hooks/useInGridElements';

const INGRID_ELEMENTS_MODE = {
    GRID: 'grid',
    LIST: 'list',
};

const isQuickLink = element => element.type === 'quick';
const isTipsheetCard = element => element.type === 'tipsheet';

export default function InGridElementsWrapper({
    showQuickFilters,
    showTipsheet,
    isCategorySearch,
    index,
    nbOfProductCards,
    mode,
}) {
    const paginationOffset = usePaginationOffset();
    const [featureFlags] = useFeatureFlags({
        maxPercentageOfInGridElements:
            'instantSearch.maxPercentageOfInGridElements',
        minHitsLength: 'instantsearch.minHitsLengthForInGridElements',
    });
    const [elements] = useInGridElements({
        showQuickFilters,
        showTipsheet,
        nbOfProductCards,
        index,
        listingOffset: paginationOffset.listingOffset,
        firstPageLength: paginationOffset.firstPageLength,
    });

    const gap = getGap(
        nbOfProductCards,
        elements.length,
        featureFlags.maxPercentageOfInGridElements,
    );
    const elementIndex = getElementIndex(elements.length, index, gap);
    const element = elements[elementIndex];

    if (!element) {
        return null;
    }
    const targetedPosition = getTargetPosition(
        elementIndex,
        gap,
        nbOfProductCards,
        index,
        featureFlags.minHitsLength,
    );

    return (
        <PositionedCard
            targetedPosition={targetedPosition}
            currentPosition={index}
            nbOfProductCards={nbOfProductCards}
        >
            {({ className }) => (
                <Fragment>
                    {showQuickFilters && isQuickLink(element) && (
                        <QuickFiltersWrapper
                            className={className}
                            isInCategorySearch={isCategorySearch}
                            quickFilters={element}
                            mode={mode}
                        />
                    )}
                    {showTipsheet && isTipsheetCard(element) && (
                        <TipsheetCard
                            className={className}
                            backgroundPicture={element.background_picture}
                            link={element.link}
                            title={element.title}
                            headlineTitle={element.headline_title}
                            mode={mode}
                        />
                    )}
                </Fragment>
            )}
        </PositionedCard>
    );
}

InGridElementsWrapper.propTypes = {
    showQuickFilters: bool.isRequired,
    showTipsheet: bool.isRequired,
    isCategorySearch: bool,
    index: number.isRequired,
    nbOfProductCards: number.isRequired,
    mode: oneOf([INGRID_ELEMENTS_MODE.GRID, INGRID_ELEMENTS_MODE.LIST]),
};

InGridElementsWrapper.defaultProps = {
    isCategorySearch: false,
    mode: INGRID_ELEMENTS_MODE.GRID,
};
